import React from 'react';
import { colors, spacing } from '../design-system/tokens';
import { Typography } from '../design-system/typography';

export interface WeightDataRowProps {
  label: string;
  weight: {
    lbs: string;
    kg: string;
  };
  className?: string;
}

export const WeightDataRow: React.FC<WeightDataRowProps> = ({
  label,
  weight,
  className = '',
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.xs,
        minWidth: 0, // Allow shrinking
        width: '100%',
      }}
    >
      {/* Label */}
      <Typography 
        variant="ledgerLabel" 
        as="div"
        style={{ 
          color: colors.text.primary,
          textTransform: 'uppercase'
        }}
      >
        {label}
      </Typography>

      {/* Primary value (lbs) */}
      <Typography 
        variant="valueAddress" 
        as="div"
        style={{ 
          color: colors.text.primary,
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }}
      >
        {weight.lbs}
      </Typography>

      {/* Secondary value (kg) */}
      <Typography 
        variant="valueAddress" 
        as="div"
        style={{ 
          color: '#94B2B8', // Primary/40 color from Figma
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }}
      >
        {weight.kg}
      </Typography>
    </div>
  );
};